export default "__VITE_ASSET__BJf3bUt3__"